import type { TableSemanticSchema } from './types';

export const LeanSchema: TableSemanticSchema = {
  id: 'lean',
  name: 'Lean Canvas',
  description:
    'Ash Maurya 9-block canvas — replaces BMC partnerships/activities/resources/relationships with problem/solution/key-metrics/unfair-advantage. Carries pivot notes across iterations.',
  cells: [
    { id: 'problem', label: 'Problem' },
    { id: 'solution', label: 'Solution' },
    { id: 'key_metrics', label: 'Key Metrics' },
    { id: 'unique_value_proposition', label: 'Unique Value Proposition' },
    { id: 'unfair_advantage', label: 'Unfair Advantage' },
    { id: 'channels', label: 'Channels' },
    { id: 'customer_segments', label: 'Customer Segments' },
    { id: 'cost_structure', label: 'Cost Structure' },
    { id: 'revenue_streams', label: 'Revenue Streams' },
  ],
  itemFields: [
    { key: 'block', label: 'Block', kind: 'enum', required: true,
      options: [
        { value: 'problem', label: 'Problem' },
        { value: 'solution', label: 'Solution' },
        { value: 'key_metrics', label: 'Key Metrics' },
        { value: 'unique_value_proposition', label: 'Unique Value Proposition' },
        { value: 'unfair_advantage', label: 'Unfair Advantage' },
        { value: 'channels', label: 'Channels' },
        { value: 'customer_segments', label: 'Customer Segments' },
        { value: 'cost_structure', label: 'Cost Structure' },
        { value: 'revenue_streams', label: 'Revenue Streams' },
      ] },
    { key: 'hypothesisStatus', label: 'Hypothesis Status', kind: 'enum',
      options: [
        { value: 'unvalidated', label: 'Unvalidated' },
        { value: 'testing', label: 'Testing' },
        { value: 'validated', label: 'Validated' },
        { value: 'invalidated', label: 'Invalidated' },
      ] },
    { key: 'pivotNote', label: 'Pivot Note', kind: 'string',
      description: 'Why this item changed across canvas iterations.' },
  ],
  renderingHints: { layout: 'grid' },
};
